import * as React from "react";
const SvgChildJoin = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path stroke="#9F9FA9" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M1 5v4a2 2 0 0 0 2 2h5" /></svg>;
export default SvgChildJoin;